export enum LetterType {
    FirstNotice = 1,
    SecondNotice = 2,
    ScofflawLetter = 3,
    FullPaymentNotReceived = 4,
    PaymentNotReceived = 5,
    InsufficientFunds = 6,
    RequestForCitationDismissal = 7,
    RequestForCitationDismissal_TooLate = 8,
    RequestForCitationDismissal_Approved = 9,
    RequestForCitationDismissal_Denied = 10,
    RequestForCitationDismissal_AdditionalInfoNeeded = 11,
    RequestForCitationDismissal_LateFeeRemoved = 12,
    RequestForCitationDismissal_ReducedToWarning = 13,
    RequestForCitationDismissal_HearingScheduled = 14,
    RequestForCitationDismissal_Hearing_AppealDenied = 15,
    RequestForCitationDismissal_Hearing_AppealApproved = 16,
    RequestForCitationDismissal_Hearing_AppealApproved_ReducedToWarning = 17,
    RequestForCitationDismissal_Hearing_AppealApproved_FineReduced = 18,
    Hearing_Adjournment_Notice = 54,
    Hearing_Officer_Court_Notice = 55,
    Hearing_Court_Schedule_Notice = 56,
    PaymentReceipt = 19,
    ThirdNotice = 37,
    PermitRenewal = 38,
    OutstandingBalance = 39,
    BaggingReport = 41,
    MonthlyStatement = 42,
    PermitInvoice = 124,
    PermitInvoiceReceipt = 125,
    RentalCarCitationsLetter = 126,
    PermitInvoiceWelcomeEmail = 127,
    PermitInvoiceKeyResetRequest = 128,
    PermitInvoiceKeyResetComplete = 129,
    CheckPaymentInformation = 130,
    PermitApplicationAcknowledgement = 1152,
    BootReleaseHoldReceipt = 151
}
